// Func = limiting Scope for this file
let lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

; (function () {
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	const langJP = document.querySelectorAll(
		"#select_languaje option[value='ja'], #select_languaje_buger option[value='ja']",
	)
	langJP.forEach((input) => {
		input.textContent = '日本語'
	})

	const header_Title = document.querySelector('[data-titleheader]')

	if (header_Title) {
		const header_Content = document.querySelector('.header__middle')
		const header_TitleText = `<span class="header__title container">${header_Title.dataset.titleheader}</span>`
		header_Content.insertAdjacentHTML('afterbegin', header_TitleText)
	}

	// Header Notice
	const header_Notice = document.querySelector('[data-notice]')
	if (header_Notice) {
		const header_Cta = document.querySelector('[data-ctanotice]')
		header_Cta.addEventListener('click', (e) => {
			e.preventDefault()
			header_Notice.classList.toggle('remove')
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)
	// Custom video functionality
	const videoControlsCustom = document.querySelector('.video-custom-controls')

	if (videoControlsCustom) {
		const videoElement = document.querySelector('#hero video')

		if (videoElement.paused) {
			videoElement.controls = true
		}

		const videoNavigation = `<div class="video-custom-controls__elements">
        <div class="video-custom-controls__button">
            <button class="video-custom-controls__play" data-ctavideo aria-label="Play video"></button>
        </div>
        <div class="video-custom-controls__timeline" data-timelinevideo>
            <div class="timeline-progress">
                <div class="timeline-progress__bar" data-progressbar></div>
            </div>
            
        </div>
    </div>`

		videoControlsCustom.insertAdjacentHTML('afterbegin', videoNavigation)

		const videoPlay = document.querySelector('[data-ctavideo]')
		const videoTimeline = document.querySelector('[data-timelinevideo]')
		const progressBar = document.querySelector('[data-progressbar]')

		const updateProgress = () => {
			if (videoElement.duration) {
				const percent = (videoElement.currentTime / videoElement.duration) * 100
				const roundedPercent = Math.round(percent)
				progressBar.style.width = `${percent}%`
			}
		}

		videoPlay.addEventListener('click', (e) => {
			e.preventDefault()
			if (videoElement.paused) {
				videoElement.controls = true
				videoElement.play()
			} else {
				videoElement.pause()
				videoElement.controls = true
			}
		})

		videoElement.addEventListener('play', () => {
			videoElement.controls = false
			videoPlay.classList.add('play')
		})

		videoElement.addEventListener('pause', () => {
			videoElement.controls = true
			videoPlay.classList.remove('play')
		})

		videoElement.addEventListener('playing', () => {
			videoElement.controls = false
		})

		videoElement.addEventListener('timeupdate', updateProgress)

		videoElement.addEventListener('ended', () => {
			progressBar.style.width = '100%'
			videoPlay.classList.remove('play')
			videoElement.controls = true
		})

		videoElement.addEventListener('loadedmetadata', () => {
			updateProgress()
		})

		videoTimeline.addEventListener('click', (e) => {
			if (videoElement.duration) {
				const timelineRect = videoTimeline.getBoundingClientRect()
				const clickX = e.clientX - timelineRect.left
				const timelineWidth = timelineRect.width
				const percent = clickX / timelineWidth
				videoElement.currentTime = percent * videoElement.duration
				updateProgress()
			}
		})
	}

	// Burger Menu Funcionality Open and Close Menu
	const btn_Menu = document.querySelectorAll('[data-ctaburger]')
	const menu_Section = document.querySelector('[data-menuburger]')
	btn_Menu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			cta.classList.toggle('open')
			menu_Section.classList.toggle('open')
			document.querySelector('body').classList.toggle('no-scroll')
			document.querySelector('header').classList.toggle('burger-open')
		})
	})

	//scroll navigation down
	const scrollDown = document.querySelectorAll(
		'#prilety-navigation a, .burger-menu__mainnav a',
	)

	if (scrollDown.length > 0) {
		scrollDown.forEach((item) => {
			item.addEventListener('click', function (e) {
				const hash = e.currentTarget.hash

				if (!hash) return
				e.preventDefault()

				const sectiongoto = hash.replace('#', '')

				if (menu_Section && menu_Section.classList.contains('open')) {
					if (btn_Menu && btn_Menu.length) {
						btn_Menu.forEach(function (cta) {
							cta.classList.remove('open')
						})
					}

					menu_Section.classList.remove('open')
					document.body.classList.remove('no-scroll')
				}

				console.log(sectiongoto)

				const targetEl = document.querySelector(hash)
				if (targetEl) {
					animateTo(hash)
				}
			})
		})
	}
	//special scroll
	const specialScroll = document.querySelectorAll('.special-scroll, .travel-experience__timecopy a');

	if (specialScroll.length > 0) {
		specialScroll.forEach((link) => {
			link.addEventListener('click', function (e) {
				const hash = link.hash;

				if (hash && hash !== '#') {
					const targetEl = document.querySelector(hash);

					if (targetEl) {
						e.preventDefault();
						animateTo(hash, { offset: 100, duration: 1300 });
						return;
					}
				}

			});
		});
	}

	// Section Go To - VERIFICA POSICIÓN EN VIEWPORT
	const urlParams = new URLSearchParams(window.location.search)
	const sectionGoto = urlParams.get('scrollgoto')
	console.log('Section GoTo:', sectionGoto);

	if (sectionGoto) {
		const targetId = sectionGoto.startsWith('#') ? sectionGoto : `#${sectionGoto}`

		window.addEventListener('load', () => {
			setTimeout(() => {
				const element = document.querySelector(targetId)
				if (element) {
					console.log('Elemento encontrado, haciendo scroll...');
					animateToViewportCenter(targetId, { duration: 1300 })
				} else {
					console.error('Elemento no encontrado:', targetId);
				}
			}, 800)
		})
	}

	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll] , .scroll')
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				if (
					section_to_scroll.href.includes('section#') ||
					section_to_scroll.href.includes('#form_id')
				) {
					let section_to_scroll_id = section_to_scroll.hash.split('#')[1]
					console.log(section_to_scroll_id)
					animateTo(`#${section_to_scroll_id}`)
				} else {
					animateTo(section_to_scroll.hash, { offset: 120, duration: 1300 })
				}
			})
		})
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll('[data-accodion] .tab-js')
	normal_accordion.forEach((item, i) => {
		item.addEventListener('click', (element) => {
			element.target.classList.toggle('active')
			element.target.nextElementSibling.classList.toggle('active')
		})
	})

	// Topics Page
	if (document.querySelector('.topic-block')) {
		let selectedTag = 'all'
		const activeTab = document.querySelector('.js-topic-tab.active')
		if (activeTab && activeTab.dataset && activeTab.dataset.target) {
			selectedTag = activeTab.dataset.target
		}

		let selectedPrefecture = 'all'
		const prefectureSelect = document.querySelector('#topicPrefecture')
		if (prefectureSelect && prefectureSelect.value) {
			selectedPrefecture = prefectureSelect.value
		}

		let currentIndex = 0
		const ITEMS_PER_PAGE = 9
		const allItems = Array.from(document.querySelectorAll('.js-topic-item'))
		const loadMoreBtn = document.querySelector('[data-more]')
		const resultsStatus = document.querySelector('#resultsStatus')

		function getMatchingItems(tag, prefecture) {
			return allItems.filter((item) => {
				const itemTags = item.dataset.tag || ''
				const itemPrefecture = item.dataset.prefecture || ''
				const matchTag = tag === 'all' || itemTags === tag
				const matchPrefecture =
					prefecture === 'all' || itemPrefecture === prefecture
				return matchTag && matchPrefecture
			})
		}

		function renderTopics(tag, prefecture, append = false) {
			const matching = getMatchingItems(tag, prefecture)

			if (!append) {
				currentIndex = 0
				allItems.forEach((item) => item.classList.add('hidden'))
			}

			const startIndex = append ? currentIndex : 0
			const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, matching.length)

			for (let i = startIndex; i < endIndex; i++) {
				matching[i].classList.remove('hidden')
			}
			currentIndex = endIndex

			if (matching.length === 0) {
				if (resultsStatus) resultsStatus.classList.remove('hidden')
				if (loadMoreBtn) loadMoreBtn.classList.add('hidden')
			} else {
				if (resultsStatus) resultsStatus.classList.add('hidden')
				if (loadMoreBtn) {
					if (currentIndex >= matching.length) {
						loadMoreBtn.classList.add('hidden')
					} else {
						loadMoreBtn.classList.remove('hidden')
					}
				}
			}
		}

		renderTopics(selectedTag, selectedPrefecture)

		document.querySelectorAll('.js-topic-tab').forEach((tab) => {
			tab.addEventListener('click', () => {
				document.querySelectorAll('.js-topic-tab').forEach((t) => {
					t.classList.remove('active')
					t.setAttribute('aria-selected', 'false')
				})
				tab.classList.add('active')
				tab.setAttribute('aria-selected', 'true')
				if (tab.dataset && tab.dataset.target) {
					selectedTag = tab.dataset.target
				}
				renderTopics(selectedTag, selectedPrefecture)
			})
		})

		if (prefectureSelect) {
			prefectureSelect.addEventListener('change', () => {
				if (prefectureSelect.value) {
					selectedPrefecture = prefectureSelect.value
				}
				renderTopics(selectedTag, selectedPrefecture)
			})
		}

		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', (e) => {
				e.preventDefault()
				renderTopics(selectedTag, selectedPrefecture, true)
			})
		}
	}

	// Travel Ideas Page
	if (document.querySelector('.travel-ideas')) {
		const areaFilter = document.getElementById('area-filter');
		const categoryFilter = document.getElementById('category-filter');
		const allItems = document.querySelectorAll('.travel-ideas__item');
		const loadMoreBtn = document.querySelector('[data-more]');
		const ctaMoreContainer = document.querySelector('.travel-ideas__ctamore');
		const resultsStatus = document.getElementById('resultsStatus');

		let visibleCount = 9;

		function renderItems() {
			const selectedArea = areaFilter ? areaFilter.value : 'all';
			const selectedCategory = categoryFilter ? categoryFilter.value : 'all';
			let matchingItems = [];

			allItems.forEach((item) => {
				const rawArea = item.getAttribute('data-area') || '';
				const rawCategory = item.getAttribute('data-category') || '';

				const itemAreas = rawArea.split(',').map((a) => a.trim()).filter((a) => a !== '');
				const itemCategories = rawCategory.split(',').map((c) => c.trim()).filter((c) => c !== '');

				const areaMatch =
					selectedArea === 'all' ||
					selectedArea === '' ||
					itemAreas.includes(selectedArea);

				const categoryMatch =
					selectedCategory === 'all' ||
					selectedCategory === '' ||
					selectedCategory === 'すべて' ||
					itemCategories.includes(selectedCategory);

				if (areaMatch && categoryMatch) {
					matchingItems.push(item);
				}
			});

			allItems.forEach((item) => item.classList.add('hidden'));

			if (matchingItems.length === 0) {
				if (resultsStatus) resultsStatus.classList.remove('hidden');
				if (ctaMoreContainer) ctaMoreContainer.classList.add('hidden');
			} else {
				if (resultsStatus) resultsStatus.classList.add('hidden');
				matchingItems.slice(0, visibleCount).forEach((item) => {
					item.classList.remove('hidden');
				});

				if (matchingItems.length > visibleCount) {
					if (ctaMoreContainer) ctaMoreContainer.classList.remove('hidden');

					if (loadMoreBtn) {
						const remaining = matchingItems.length - visibleCount;
						const toLoad = Math.min(9, remaining);
						loadMoreBtn.setAttribute('aria-label', `さらに${toLoad}件を表示`);
					}
				} else {
					if (ctaMoreContainer) ctaMoreContainer.classList.add('hidden');
				}
			}
		}

		if (areaFilter) {
			areaFilter.addEventListener('change', () => {
				visibleCount = 9;
				renderItems();
			});
		}

		if (categoryFilter) {
			categoryFilter.addEventListener('change', () => {
				visibleCount = 9;
				renderItems();
			});
		}

		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', (e) => {
				e.preventDefault();
				visibleCount += 9;
				renderItems();
			});
		}

		renderItems();
	}

	// Travel Days Itinerary special character
	if (document.querySelector('.travel-days-itinerary')) {
		document.querySelectorAll('.travel-days-itinerary p').forEach((el) => {
			console.log(el)
			el.innerHTML = el.innerHTML.replace(/~/g, '<span class="tilde">~</span>')
		})
	}

	//Navigation for travel ideas
	initSubnavigation()

})()

function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop

	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up', 'down')
		}
	}

	lastScrollTop = st <= 0 ? 0 : st
}

function animateToViewportCenter(target, options = {}) {
	const duration = options.duration || 1300
	const tolerance = options.tolerance || 50 // Tolerancia en píxeles

	const element = typeof target === 'string' ? document.querySelector(target) : target
	if (!element) {
		console.error('Elemento no encontrado para animar:', target)
		return
	}

	const startTime = performance.now()
	let animationFrame

	function easeInOutQuart(t) {
		return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
	}

	function animate(currentTime) {
		const elapsed = currentTime - startTime
		const progress = Math.min(elapsed / duration, 1)
		const easedProgress = easeInOutQuart(progress)

		const rect = element.getBoundingClientRect()
		const viewportHeight = window.innerHeight
		const elementCenter = rect.top + (rect.height / 2)
		const viewportCenter = viewportHeight / 2

		const distanceToCenter = elementCenter - viewportCenter

		if (Math.abs(distanceToCenter) <= tolerance) {
			console.log('Elemento en el centro del viewport, deteniendo animación')
			cancelAnimationFrame(animationFrame)
			return
		}

		const scrollAmount = distanceToCenter * easedProgress * 0.1
		window.scrollBy(0, scrollAmount)

		if (progress < 1) {
			animationFrame = requestAnimationFrame(animate)
		} else {
	
			console.log('animation ended')
		}
	}

	animationFrame = requestAnimationFrame(animate)

	return {
		cancel: () => cancelAnimationFrame(animationFrame)
	}
}

function animateTo(target, options = {}) {
	const offsetValue = options.offset || 0
	const duration = options.duration || 1300

	const element = typeof target === 'string' ? document.querySelector(target) : target
	if (!element) {
		console.error('element not found for animation:', target)
		return
	}

	const startPosition = window.pageYOffset
	const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offsetValue
	const distance = targetPosition - startPosition
	const startTime = performance.now()

	function easeInOutQuart(t) {
		return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t
	}

	function animate(currentTime) {
		const elapsed = currentTime - startTime
		const progress = Math.min(elapsed / duration, 1)
		const easedProgress = easeInOutQuart(progress)
		const currentPosition = startPosition + (distance * easedProgress)
		window.scrollTo(0, currentPosition)

		if (progress < 1) {
			requestAnimationFrame(animate)
		} else {
			window.scrollTo(0, targetPosition)
		}
	}

	requestAnimationFrame(animate)
}

function getElementOffset(el) {
	const rect = el.getBoundingClientRect()
	return {
		top: rect.top + window.pageYOffset,
		left: rect.left + window.pageXOffset,
	}
}

let currentSubnavAnimation = null;

function initSubnavigation() {
	const navs = document.querySelectorAll('.subnavigation-nav .sub-menu');
	if (!navs.length) return;

	const groups = document.querySelectorAll('.shortcode-group-wrapper');
	if (!groups.length) return;

	navs.forEach(function (nav) {
		const links = nav.querySelectorAll('li a');
		links.forEach(function (link, index) {
			link.addEventListener('click', function (e) {
				e.preventDefault();

				const targetGroup = groups[index];
				if (!targetGroup) return;

				if (currentSubnavAnimation && currentSubnavAnimation.cancel) {
					currentSubnavAnimation.cancel();
				}

				currentSubnavAnimation = animateTo(targetGroup, {
					offset: 100,
					duration: 1300
				});

				setActiveLink(index, navs);
			});
		});
	});

	setupScrollSpy(groups, navs);
}

function setActiveLink(activeIndex, navs) {
	navs.forEach(function (nav) {
		const links = nav.querySelectorAll('li a');
		links.forEach(function (link, i) {
			if (i === activeIndex) {
				link.classList.add('active');
				link.parentElement.classList.add('active');
			} else {
				link.classList.remove('active');
				link.parentElement.classList.remove('active');
			}
		});
	});
}

function setupScrollSpy(groups, navs) {
	const observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					const index = Array.prototype.indexOf.call(groups, entry.target);
					if (index !== -1) {
						setActiveLink(index, navs);
					}
				}
			});
		},
		{
			root: null,
			rootMargin: '-30% 0px -60% 0px',
			threshold: 0
		}
	);

	groups.forEach(function (group) {
		observer.observe(group);
	});
}